<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="保险方案" prop="insuranceProductId">
        <sl-select v-model="form.insuranceProductId" :data="products" :filterable="true" @on-change="handleChange" :full-props="true"></sl-select>
      </FormItem>
      <FormItem label="公司">
        <Input :value="data.companyName" disabled></Input>
      </FormItem>
      <FormItem label="保障年限">
        <Input :value="data.insuranceYear" disabled></Input>
      </FormItem>
      <FormItem label="保险费用">
        <Input v-model="data.price" disabled></Input>
      </FormItem>
      <FormItem>
        <Button @click="reset">重置</Button>
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </FormItem>
    </Form>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      action:null,
      rules: {
        insuranceProductId: [ { type:'number', required:true , message: '保险方案不能为空', trigger: 'blur,change' } ],
      },
      form: {
        insuranceProductId: null,
      },
      data:{},
      products:[],
      loading:false
    }
  },

  props:{
    orderId:{

    }
  },
  watch:{
    orderId(val){

      if(val){
        this.query()
      }

    }
  },

  mounted() {},

  methods: {
    init(id) {
      this.form.id = id
    },

    query(){
      this.$refs['form'].resetFields()
      
      this.$request.insurances({pageSize:9999}).then(resp=>{
        this.products = (resp.data.list || []).map(i=>({value:i.id , label :i.name , raw : i}))
        this.$request.orderInsuranceQuery(this.orderId).then(resp => {
          if(!resp.code){
            this.def = resp.data

            this.$utils.fill(this.form , this.def)

            this.data = {...resp.data}
            if( this.data.insuranceProductId ){
              let hit = this.products.find( i => i.value == this.data.insuranceProductId )
              if(hit){
                this.data.companyName = hit.raw.companyName

              }
            }
          }else{
            this.$Message.error({content:resp.message})
          }
        })
      })
    },

    save() {
      let params = { orderId: this.orderId, ...this.form }

      this.loading = true
      this.$request.orderInsuranceUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
          // this.$keepAlive.update()
        }
        this.loading = false
      })

    },
    reset(){
      this.$utils.fill(this.form , this.def)
      this.data = this.def
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleChange(v){
      this.data = v.raw
    }
  }
}
</script>